import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'

import {KMS_WIDGET_NAMESPACE} from '../consts'

const kmsTranslationModule: TranslationModule = {
  namespace: KMS_WIDGET_NAMESPACE,
  resources: {
    'de-DE': () => import('./de_DE.json'),
    'en-GB': () => import('./en_GB.json'),
    'en-US': () => import('./en_GB.json')
  }
}

const externalPackageTranslations: TranslationModule[] = []

export const kmsWidgetTranslations = combineTranslationBundles([
  externalPackageTranslations,
  kmsTranslationModule
])
